import { styled } from '../theme';

const TableCell = styled('td')<{ wordBreak?: boolean }>(({ theme, wordBreak }) => ({
    wordBreak: wordBreak ? 'break-word' : 'normal',
    display: 'table-cell',
    padding: 30,
    textAlign: 'left',
    verticalAlign: 'inherit',
    fontSize: '1.55rem',
}));

export default TableCell;
